export default "__VITE_PUBLIC_ASSET__6514da80__"